import { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import './LogoCarousel.scss';
import { LogoCarouselItem } from './LogoCarouselItem';

export const LogoCarousel = ({ enlaces }) => {
  const [currentLogoPosition, setCurrentLogoPosition] = useState(0);
  const scrollNext = () => {
    if (!shouldDisableNext()) {
      setCurrentLogoPosition(currentLogoPosition + 1);
    }
  };
  const scrollPrev = () => {
    if (currentLogoPosition > 0) {
      setCurrentLogoPosition(currentLogoPosition - 1);
    }
  };
  const shouldDisableNext = () => {
    //Modificacion: Marca de Inicio WII C-24-1229-24
    return window.innerWidth / 268 + currentLogoPosition > enlaces.length + 1;
    //Modificacion: Marca de Fin WII C-24-1229-24
  };
  return (
    <div className="logo-carousel-container">
      <Button
        disabled={currentLogoPosition == -999}
        onClick={scrollPrev}
        className="btn-nav btn-prev"
        variant="light"
      >
        <div className="material-icons-outlined">chevron_left</div>
      </Button>
      <div className="logos">
        {enlaces.map((enlace) => {
          return (
            <LogoCarouselItem
              key={enlace.enlace_id}
              enlace={enlace}
              style={{
                //Modificacion: Marca de Inicio WII C-24-1229-24
                transform: 'translateX(-' + currentLogoPosition * 298 + 'px)',
                //Modificacion: Marca de Fin WII C-24-1229-24
              }}
            ></LogoCarouselItem>
          );
        })}
      </div>
      <Button
        className="btn-nav btn-next"
        variant="light"
        onClick={scrollNext}
      >
        <div className="material-icons-outlined">chevron_right</div>
      </Button>
    </div>
  );
};
